import { Component, Prop, Vue } from 'vue-property-decorator';
import NoteTaskDetailsReq from '../../../../../models/NoteTaskDetailsRequest';
import NoteTaskPrintReq from '../../../../../models/NoteTaskPrintRequest';
import NotesTasksService from '../../../../../services/NoteTaskService';
const Email = require('../../../../../components/email/email.vue.html');
const Grid = require('../../../../../components/grid/grid.vue.html');
const Attachments = require('../../../../../components/attachments/attachments.vue.html');
const NoteTask = require('../notetask/notetask.vue.html');
//const NoteTask = require('../notetask.vue.html');

@Component({
    components: {
        Email,
        Grid,
        Attachments
        , NoteTask
    }
})
export default class NoteTaskList extends Vue {
    @Prop({ type: Object, required: true }) grid!: any;
    @Prop() gridTitle!: string;
    @Prop() hearingDetails!: any;

    printDialog: Boolean = false;
    noteTaskDialog: Boolean = false;
    editedItem: number = 0;
    editedIndex: number = -1;
    pkNoteId: number = 0;
    gridActions: Array<any> = [];

    get selectedGridItems() {
        if (this.grid.selected)
            return this.grid.selected.length;
        else
            return 0;
    }

    public service = new NotesTasksService();

    newItem() {
        this.editedIndex = -1;
        this.editedItem = 0;
        this.noteTaskDialog = true;
    }

    editItem(item: any) {
        this.noteTaskDialog = true;
        this.editedItem = item.id;
    }

    print(logo: boolean) {
        let data: NoteTaskDetailsReq = { pkNoteIDs: [] };

        for (var i = 0; i < this.grid.selected.length; i++) {
            data.pkNoteIDs.push(this.grid.selected[i].id);
        }

        this.service.GetNoteDetails(data)
            .then((response: NoteTaskPrintReq) => {
                if (response) {
                    this.printDialog = false;

                    response.createdBy = this.$store.state.user.userName;
                    response.documentName = this.hearingDetails.pkHearing + "_Notes";
                    response.documentTitle = "Notes for " + this.hearingDetails.pkHearing;
                    response.description = "Notes for Hearing ID: " + this.hearingDetails.pkHearing;
                    response.logoIncluded = logo;
                    response.policyNum = this.hearingDetails.policyNumber;
                    response.claimNum = this.hearingDetails.claimNumber;
                    var claimantFullName = this.hearingDetails.claimantNameFirst + ' ';
                    if (this.hearingDetails.claimantNameMiddle)
                        claimantFullName += this.hearingDetails.claimantNameMiddle + ' ';
                    claimantFullName += this.hearingDetails.claimantNameLast;
                    response.injuryDate = this.hearingDetails.injuryDate;
                    response.name = claimantFullName;
                    response.displayListItems = response.notesDetailsDTO;

                    this.service.PrintNotes(response)
                        .then((response) => {
                            this.$store.dispatch("isLoading", false);
                            // It is necessary to create a new blob object with mime-type 
                            // explicitly set otherwise only Chrome works like it should
                            let newBlob = new Blob([response], { type: response.type });

                            // IE doesn't allow using a blob object directly as link href 
                            // instead it is necessary to use msSaveOrOpenBlob
                            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                                window.navigator.msSaveOrOpenBlob(newBlob);
                                return;
                            }

                            // For other browsers: 
                            // Create a link pointing to the ObjectURL containing the blob.
                            let data = window.URL.createObjectURL(newBlob);
                            let link = document.createElement('a');
                            link.href = data;
                            link.target = "_blank";
                            //link.download = "testing.pdf";    //this will force it to download automatically
                            link.click();
                            setTimeout(() => {
                                // For Firefox it is necessary to delay revoking the ObjectURL
                                window.URL.revokeObjectURL(data);
                            }, 100);

                            
                        })
                }
                else
                    this.$store.dispatch("isLoading", false);
            })
            .catch(error => { });
    }

    completeTask(item: any) {
        let req: any = {
            pkNote: item.id
            , user: this.$store.state.user.userName
        };

        this.service.SaveNoteAssignments(req).
            then((resp) => {
                this.$emit('refreshData');
            });
    }

    closeDialog() {
        //todo: sc - refreshing data causes applicationMessages to not be displayed. why?
        //this.$emit('refreshData');
        this.noteTaskDialog = false;
        this.$store.dispatch("isLoading", false);
    }
}


// WEBPACK FOOTER //
// ./ClientApp/src/portalhome/docketing/pages/hearingdetails/notetask/notetasklist.ts